export const LINKS = {
  HOME: "/",
  FINANCE: "/finance",
  CLICK_DAY: "/click-day",
  LOCAL_ANNOUNCEMENTS: "/local-announcements",
  BUILD_YOUR_SOLUTION: `/build-your-solution`,
  INDUSTRY_4: "/industry-4-0",
  INDUSTRY_5: "/industry-5-0",
  NUOVA_SABATINI: "/nuova-sabatini",
  ZES: "/zes",
  SIMEST: "/simest",
  GESTIONE_CONTRIBUTI: "/gestione-contributi",
  PERIZIE_4: "/perizie-industra-4-0",
  CERTIFICAZIONE_5: "/certificazione-industra-5-0",
  PERIZIE_INAIL: "/perizie-bando-isi-inail",
  SOFTWARE_MES_4: "/software-mes",
  ABOUT: "/about",
  CONTACTS: "/contacts",
  PARTNERS: "/partners",
  PARTNER_DETAIL: "/partner/:id",
  REQUEST_CONFIRMED: "/rquest-confirmed",
  FACEBOOK: "https://www.facebook.com/prossimiti",
  LINKEDIN: "https://www.linkedin.com/company/prossimiti",
  INSTAGRAM: "https://www.instagram.com/prossimiti",
};
